import importacao from '../../../vuex/modules/importacao';
import controlador from './modules/controlador';
import metadados from '../../../vuex/modules/metadados';
import roles from '../../../vuex/modules/roles';
import usuario from '../../../vuex/modules/usuario';
import parametros from '../../../vuex/modules/parametros';
import implantacao from '../../../vuex/modules/implantacao';

// A Vuex instance is created by combining the state, the actions,
// and the mutations. Because the actions and mutations are just
// functions that do not depend on the instance itself, they can
// be easily tested or even hot-reloaded (see counter-hot example).

export default {
  modules: {
    importacao,
    controlador,
    metadados,
    roles,
    usuario,
    parametros,
    implantacao,
  },
  strict: true,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/vuex/store.js